<template>
  <v-container fluid>
    <v-card>
      <v-card-title>
        <span class="headline mb-0">企業検索</span>
      </v-card-title>
      <v-card-actions>
        <v-btn
          @click="search"
          class="btn-search"
          v-permit.SHARP_COMPANY_SEARCH
          >{{ $t("app.buttons.search") }}</v-btn
        >
        <v-btn @click="create" v-permit.SHARP_COMPANY_NEW>{{
          $t("app.buttons.new")
        }}</v-btn>
        <v-btn
          :disabled="selected.length != 1"
          @click="edit"
          v-permit.SHARP_COMPANY_EDIT.v-permit.SHARP_COMPANY_DETAIL
          >{{ $t("app.buttons.edit") }}</v-btn
        >
        <v-btn
          :disabled="selected.length == 0"
          @click="remove"
          v-permit.SHARP_COMPANY_DELETE
          >{{ $t("app.buttons.remove") }}</v-btn
        >
        <v-btn @click="downloadExcel">検索結果出力</v-btn>
      </v-card-actions>
      <v-form>
        <v-container fluid>
          <v-layout row wrap>
            <v-flex md3 sm6 xs12>
              <v-text-field clearable label="CD" v-model="query.code" />
            </v-flex>
            <v-flex md3 sm6 xs12>
              <v-text-field
                clearable
                label="企業"
                v-model="query.companyName"
              />
              <!-- <remote-autocomplete label="企業" url="companies/kv" v-model="query.companyId"></remote-autocomplete> -->
            </v-flex>
            <v-flex md3 sm6 xs12>
              <remote-autocomplete
                label="所在地"
                url="countries/kv"
                v-model="query.countryCode"
              ></remote-autocomplete>
            </v-flex>
            <!-- <v-flex md3 sm6 xs12>
              <v-text-field clearable label="代表電話" v-model="query.companyTel"/>
            </v-flex>
            <v-flex md3 sm6 xs12>
              <v-text-field clearable label="代表FAX" v-model="query.companyFax"/>
            </v-flex>-->
            <v-flex md3 sm6 xs12>
              <v-select
                :items="$store.state.companyType"
                clearable
                item-text="text"
                item-value="value"
                label="企業区分"
                @change="clearQuery()"
                v-model="query.companyType"
              />
            </v-flex>
            <v-flex md3 sm6 xs12>
              <v-text-field
                clearable
                label="担当窓口"
                v-model="query.companyContact"
              />
            </v-flex>
            <v-flex
              key="query.serviceType"
              md3
              sm6
              v-if="query.companyType == 'SUPPLIER'"
              xs12
            >
              <v-select
                :items="services"
                item-text="text"
                item-value="value"
                label="提供サービス"
                v-model="query.serviceType"
                clearable
              ></v-select>
            </v-flex>
            <v-flex
              key="query.operateDirectorId"
              md3
              sm6
              v-if="query.companyType == 'PARTNER'"
              xs12
            >
              <remote-autocomplete
                label="事業別SJL担当"
                url="employees/kv"
                v-model="query.operateDirectorId"
              ></remote-autocomplete>
            </v-flex>
            <v-flex
              key="query.deliveryDirectorId"
              md3
              sm6
              v-if="query.companyType == 'SHARP'"
              xs12
            >
              <remote-autocomplete
                label="納入指示者"
                url="employees/kv"
                v-model="query.deliveryDirectorId"
              ></remote-autocomplete>
            </v-flex>

            <v-flex
              key="query.releaseDirectorId"
              md3
              sm6
              v-if="query.companyType == 'PARTNER'"
              xs12
            >
              <remote-autocomplete
                label="D/O解除確認者"
                url="employees/kv"
                v-model="query.releaseDirectorId"
              ></remote-autocomplete>
            </v-flex>
            <v-flex
              key="query.releaseDirectorId"
              md3
              sm6
              v-if="query.companyType == 'BUYER'"
              xs12
            >
              <remote-autocomplete
                label="バイヤー"
                url="buyers/code/kv"
                v-model="query.buyerCode"
              />
            </v-flex>
            <v-flex
              key="query.releaseDirectorId"
              md3
              sm6
              v-if="query.companyType == 'PRODUCTION_BASE'"
              xs12
            >
              <remote-autocomplete
                label="生産拠点"
                url="expense-codes/code/kv"
                v-model="query.expenseCode"
              />
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </v-card>
    <total-card :item="query" @passSelected="assign" ref="total"></total-card>
  </v-container>
</template>

<script>
import TotalCard from "./TotalCard.vue";
export default {
  components: {
    TotalCard,
  },
  data() {
    return {
      companytype: [
        { text: "SJL", value: "SJL" },
        { text: "SHARP", value: "SHARP" },
        { text: "海外取引先", value: "PARTNER" },
        { text: "サプライヤー", value: "SUPPLIER" },
        { text: "得意先", value: "OVERSEAS" },
        { text: "生産拠点", value: "PRODUCTION_BASE" },
        { text: "バイヤー", value: "BUYER" },
      ],
      services: [
        { text: "フォワダー", value: "FORWARDER" },
        { text: "通関", value: "CUSTOMS_CLEARANCE" },
        { text: "ドレージ", value: "DRAKE" },
        { text: "デバン", value: "DEVAN" },
        { text: "チャーター", value: "CHARTER" },
        { text: "混載", value: "MIXLOADING" },
      ],
      query: {},
      selected: [],
      deleteId: [],
    };
  },
  methods: {
    clearQuery() {
      this.query = { companyType: this.query.companyType };
    },
    downloadExcel() {
      this.$refs.total.downloadLoad();
    },
    search() {
      this.$refs.total.pagination.page = 1;
      this.load();
    },
    load() {
      this.$storeParams();
      this.$refs.total.load();
    },
    remove() {
      this.$confirm({ content: this.$t("app.messages.removeConfirm") }).then(
        () => {
          if (this.selected.length == 0) {
            alert("you must choose one item to delete");
          } else {
            Promise.all(
              this.selected.map((i) => {
                return this.$http
                  .delete(`/companies/${i.companyId}`)
                  .then(() => {
                    this.selected = [];
                    this.load();
                    this.$message("", "削除成功");
                  });
              })
            );
          }
        }
      );
    },
    create() {
      this.$router.push("M0031");
    },
    edit() {
      if (this.selected.length > 1) {
        alert("no more than 1 item");
      } else {
        this.$router.push({
          path: "M0031",
          query: { id: this.selected[0].companyId },
        });
      }
    },
    assign(item) {
      this.selected = item;
    },
  },
  watch: {},
  mounted() {
    this.$loadParams();
  },
};
</script>
